import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock, Users, Utensils, Music, Map } from 'lucide-react';
import './WeddingDetails.css';

const WeddingDetails: React.FC = () => {
  const schedule = [
    {
      time: '11h',
      event: 'Início Cerimônia',
      description: 'Cerimônia de casamento',
      icon: Users
    },
    {
      time: '12h30',
      event: 'Entradas e Bebidas',
      description: 'Cocktail e recepção dos convidados',
      icon: Utensils
    },
    {
      time: '13h00',
      event: 'Almoço',
      description: 'Jantar de celebração',
      icon: Utensils
    },
    {
      time: '14h30',
      event: 'Dança dos Noivos',
      description: 'Primeira dança dos noivos',
      icon: Music
    },
    {
      time: '15h00',
      event: 'Pagode dos Cria, Drinks e Festa',
      description: 'Música ao vivo e festa',
      icon: Music
    },
    {
      time: '17h00',
      event: 'DJ',
      description: 'Música e dança',
      icon: Music
    },
    {
      time: '19h',
      event: 'FIM',
      description: 'Encerramento da celebração',
      icon: Users
    }
  ];

  const venueInfo = {
    name: 'Condomínio Ecogarden Residence',
    address: 'R. Jacob Porsak, 257 - Chácaras Aeroporto, Maringá - PR, 87035-273',
    description: 'Cerimônia e recepção no mesmo local',
    googleMapsUrl: 'https://share.google/ZHgJ9ku7j6dsWHg20'
  };

  return (
    <div className="wedding-details">
      <div className="details-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="details-hero-content"
          >
            <h1>Detalhes do Casamento</h1>
            <p>Tudo que você precisa saber sobre nosso dia especial</p>
          </motion.div>
        </div>
      </div>

      <div className="details-content">
        <div className="container">
          {/* Date and Time */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="details-section"
          >
            <div className="section-header">
              <Calendar className="section-icon" />
              <h2>Data e Horário</h2>
            </div>
            <div className="date-time-info">
              <div className="date-card">
                <h3>13 de Dezembro de 2025</h3>
                <p>Sábado</p>
              </div>
              <div className="time-card">
                <h3>11h00</h3>
                <p>Cerimônia inicia</p>
              </div>
            </div>
          </motion.div>

          {/* Schedule */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="details-section"
          >
            <div className="section-header">
              <Clock className="section-icon" />
              <h2>Cronograma</h2>
            </div>
            <div className="schedule-timeline">
              {schedule.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={index} className="schedule-item">
                    <div className="schedule-time">{item.time}</div>
                    <div className="schedule-content">
                      <div className="schedule-icon">
                        <IconComponent />
                      </div>
                      <div className="schedule-text">
                        <h3>{item.event}</h3>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </motion.div>

          {/* Venue */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="details-section"
          >
            <div className="section-header">
              <MapPin className="section-icon" />
              <h2>Local</h2>
            </div>
            <div className="venue-info">
              <div className="venue-card">
                <h3>{venueInfo.name}</h3>
                <p>{venueInfo.description}</p>
                <div className="venue-address">
                  <MapPin className="address-icon" />
                  <span>{venueInfo.address}</span>
                </div>
                <div className="venue-actions">
                  <a 
                    href={venueInfo.googleMapsUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="map-link"
                  >
                    <Map className="map-icon" />
                    Ver no Google Maps
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Google Maps Widget */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="details-section"
          >
            <div className="section-header">
              <Map className="section-icon" />
              <h2>Localização</h2>
            </div>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3659.677658951395!2d-51.90871792467252!3d-23.472088978861276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ecda4342c549eb%3A0xa1b7e297e7ea3094!2sCondom%C3%ADnio%20Ecogarden%20Residence!5e0!3m2!1spt-BR!2sbr!4v1764905720720!5m2!1spt-BR!2sbr"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização do Casamento - Condomínio Ecogarden Residence"
              />
            </div>
          </motion.div>

          {/* Additional Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.0 }}
            className="details-section"
          >
            <div className="section-header">
              <Users className="section-icon" />
              <h2>Informações Adicionais</h2>
            </div>
            <div className="additional-info">
              <div className="info-item">
                <h3>Código de Vestimenta</h3>
                <p>Traje social / Esporte fino</p>
              </div>
              <div className="info-item">
                <h3>Estacionamento</h3>
                <p>Contaremos com manobrista para auxiliar na estacionamento</p>
              </div>
              <div className="info-item">
                <h3>Hospedagem</h3>
                <p>Hotéis próximos disponíveis na região</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default WeddingDetails; 